import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import ConversationItem, { getOutgoingCommunicationStatus } from 'models/conversation_item';
import Metadata from './metadata';

export const StyledIconAPI = styled.span`
  background-color: ${p => p.theme.colors.purple500};
  border-radius: ${p => p.theme.borderRadius.default};
  color: ${p => p.theme.colors.white};
  font-size: 8px;
  font-weight: ${p => p.theme.fontWeight.medium};
  margin-right: 6px;
  padding: 2px 4px;
  vertical-align: text-top;
`;

export default function ApiMetadata({ item, prepositionalPhrases, status, text, icon }) {
  let metadataIcon = icon ? icon : <StyledIconAPI className="api-icon">APP</StyledIconAPI>;

  return (
    <Metadata
      icon={metadataIcon}
      isInbound={false}
      prepositionalPhrases={prepositionalPhrases}
      status={status ? status : getOutgoingCommunicationStatus(item)}
      subject={item.content.sourceName}
      text={text}
      timestamp={item.timestamp}
    />
  );
}

ApiMetadata.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  text: PropTypes.any,
};
